import React from 'react';

export function ArrowDownIcon(): JSX.Element {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="47" fill="none">
            <path fill="#000" d="M.5 36L11 46.5 21.5 36l-1.92-1.92-7.22 7.26V.5H9.64v40.84l-7.22-7.26L.5 36z"></path>
        </svg>
    );
}
